(function () {
  function cartUrl() { return (window.routes && window.routes.cart_url) || '/cart'; }

  async function addToCart(form) {
    var drawer = document.querySelector('cart-drawer');
    var fd = new FormData(form);
    if (drawer) {
      fd.append('sections', 'cart-drawer,cart-icon-bubble');
      fd.append('sections_url', window.location.pathname);
    }
    var res = await fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    });
    var data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart');
    if (drawer && data.sections && typeof drawer.renderContents === 'function') {
      drawer.classList.remove('is-empty');
      drawer.renderContents(data);
    } else {
      window.location.href = cartUrl();
    }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-sa-cart]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    var err = form.querySelector('.sa-form-error');
    if (err) { err.hidden = true; err.textContent = ''; }
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    addToCart(form)
      .catch(function (ex) {
        if (err) { err.textContent = ex.message; err.hidden = false; }
        else { form.removeAttribute('data-sa-cart'); form.submit(); }
      })
      .finally(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  });

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-sa-thumb]');
    if (thumb) {
      var gal = thumb.closest('[data-sa-gallery]');
      var strip = gal.querySelector('.sa-pdp__strip');
      var thumbs = Array.prototype.slice.call(gal.querySelectorAll('[data-sa-thumb]'));
      if (strip) {
        slideStrip(strip, thumbs.indexOf(thumb) * strip.clientWidth);
        thumbs.forEach(function (b) { b.setAttribute('aria-current', b === thumb ? 'true' : 'false'); });
        return;
      }
      var main = gal.querySelector('[data-sa-main]');
      main.srcset = thumb.dataset.srcset || '';
      main.src = thumb.dataset.src;
      main.alt = thumb.dataset.alt || '';
      gal.querySelectorAll('[data-sa-thumb]').forEach(function (b) { b.setAttribute('aria-current', b === thumb ? 'true' : 'false'); });
      return;
    }
    var step = e.target.closest('[data-sa-step]');
    if (step) {
      var input = step.parentElement.querySelector('input');
      var v = (parseInt(input.value, 10) || 1) + parseInt(step.dataset.saStep, 10);
      input.value = Math.max(1, v);
      return;
    }
    var go = e.target.closest('[data-sa-sticky-buy]');
    if (go) {
      var f = document.getElementById(go.dataset.saStickyBuy);
      if (f) { if (f.requestSubmit) f.requestSubmit(); else f.submit(); }
    }
  });

  document.addEventListener('change', function (e) {
    var sort = e.target.closest('[data-sa-sort]');
    if (sort) {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sort.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
      return;
    }
    var variant = e.target.closest('[data-sa-variant]');
    if (variant) {
      var opt = variant.options[variant.selectedIndex];
      var scope = variant.closest('[data-sa-pdp]');
      scope.querySelectorAll('[data-sa-price]').forEach(function (el) { el.textContent = opt.dataset.price; });
      var btn = scope.querySelector('[data-sa-add]');
      var ok = opt.dataset.available === 'true';
      btn.disabled = !ok;
      btn.querySelector('[data-sa-add-label]').textContent = ok ? btn.dataset.addLabel : btn.dataset.soldLabel;
      return;
    }
    var gift = e.target.closest('[data-sa-gift]');
    if (gift) {
      var box = gift.closest('.sa-gift').querySelector('[data-sa-gift-note]');
      box.hidden = !gift.checked;
      box.querySelectorAll('textarea,input').forEach(function (el) { el.disabled = !gift.checked; });
    }
  });

  function initSticky() {
    var bar = document.querySelector('[data-sa-sticky]');
    var buy = document.querySelector('[data-sa-buy]');
    if (!bar || !buy || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      bar.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
    }).observe(buy);
  }

  // Adds .is-in when a [data-sa-reveal] section scrolls into view (drives the icon draw-in).
  function initReveal(root) {
    var els = (root || document).querySelectorAll('[data-sa-reveal]:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.2 });
    els.forEach(function (el) { io.observe(el); });
  }

  // Product cards: the photo slides right to left through up to 6 product images.
  // Desktop: auto-slides while the cursor is on the photo, then slides on to photo 1 when it leaves.
  // Touch screens: swipe the photo by finger, dots show the position.
  function initCycle(root) {
    if (!window.matchMedia) return;
    var hover = window.matchMedia('(hover: hover)').matches;
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    (root || document).querySelectorAll('[data-sa-cycle]:not([data-sa-cycle-on])').forEach(function (m) {
      m.setAttribute('data-sa-cycle-on', '');
      var urls = (m.dataset.saCycle || '').split('|').filter(Boolean);
      var img = m.querySelector('img');
      if (!img || urls.length < 2) return;
      if (hover && !still) slideOnHover(m, img, urls); else if (!hover) swipeByTouch(m, img, urls);
    });
  }

  function slideOnHover(m, img, urls) {
    var track = null, k = 0, timer = null, wait = null, busy = false, leaving = false, n = urls.length;
    function build() {
      track = document.createElement('div');
      track.className = 'sa-cyc';
      urls.concat(urls[0]).forEach(function (u, i) {
        var x = i === 0 ? img.cloneNode() : document.createElement('img');
        if (i > 0) { x.src = u; x.alt = ''; x.decoding = 'async'; }
        x.removeAttribute('loading');
        track.appendChild(x);
      });
      m.insertBefore(track, img.nextSibling);
      track.addEventListener('transitionend', function (e) {
        if (e.target !== track) return;
        busy = false;
        if (k === n) { track.style.transition = 'none'; k = 0; track.style.transform = 'translateX(0)'; void track.offsetWidth; track.style.transition = ''; }
        if (leaving && k === 0) { m.classList.remove('is-cycling'); leaving = false; }
      });
    }
    function next() { if (busy) return; busy = true; k += 1; track.style.transform = 'translateX(' + (-k * 100) + '%)'; }
    m.addEventListener('mouseenter', function () {
      if (!track) build();
      leaving = false;
      m.classList.add('is-cycling');
      clearTimeout(wait); clearInterval(timer);
      wait = setTimeout(function () { next(); timer = setInterval(next, 1900); }, 450);
    });
    m.addEventListener('mouseleave', function () {
      clearTimeout(wait); clearInterval(timer);
      if (!track) return;
      if (k === 0 && !busy) { m.classList.remove('is-cycling'); return; }
      leaving = true;
      // Finish the loop forward (right to left) so the card always lands back on photo 1.
      if (!busy) { busy = true; k = n; track.style.transform = 'translateX(' + (-k * 100) + '%)'; }
      else { var once = function (e) { if (e.target !== track) return; track.removeEventListener('transitionend', once); if (k !== 0) { busy = true; k = n; track.style.transform = 'translateX(' + (-k * 100) + '%)'; } }; track.addEventListener('transitionend', once); }
    });
  }

  function swipeByTouch(m, img, urls) {
    var strip = document.createElement('div');
    strip.className = 'sa-cyc sa-cyc--touch';
    var dots = document.createElement('div');
    dots.className = 'sa-cyc-dots';
    urls.forEach(function (u, i) {
      var x = i === 0 ? img.cloneNode() : document.createElement('img');
      if (i > 0) { x.src = u; x.alt = ''; x.loading = 'lazy'; x.decoding = 'async'; }
      strip.appendChild(x);
      var d = document.createElement('i'); if (i === 0) d.className = 'is-on'; dots.appendChild(d);
    });
    m.insertBefore(strip, img.nextSibling);
    m.appendChild(dots);
    m.classList.add('is-cycling');
    var raf = 0;
    strip.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(strip.scrollLeft / Math.max(1, strip.clientWidth));
        Array.prototype.forEach.call(dots.children, function (d, j) { d.className = j === i ? 'is-on' : ''; });
      });
    }, { passive: true });
  }

  // Product page gallery: all photos sit side by side in one strip. Clicking a thumbnail slides
  // the strip smoothly to that photo; on touch screens the main photo can also be swiped.
  function slideStrip(strip, to) {
    cancelAnimationFrame(strip._saAnim);
    var from = strip.scrollLeft, d = to - from, t0 = null, ms = 650;
    if (!d) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) { strip.scrollLeft = to; return; }
    strip.style.scrollSnapType = 'none';
    function frame(t) {
      if (t0 === null) t0 = t;
      var p = Math.min(1, (t - t0) / ms);
      var e = p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
      strip.scrollLeft = from + d * e;
      if (p < 1) strip._saAnim = requestAnimationFrame(frame); else strip.style.scrollSnapType = '';
    }
    strip._saAnim = requestAnimationFrame(frame);
  }

  function initGallery(root) {
    (root || document).querySelectorAll('[data-sa-gallery]:not([data-sa-gallery-on])').forEach(function (gal) {
      gal.setAttribute('data-sa-gallery-on', '');
      var main = gal.querySelector('[data-sa-main]');
      var thumbs = Array.prototype.slice.call(gal.querySelectorAll('[data-sa-thumb]'));
      if (!main || thumbs.length < 2) return;
      var strip = document.createElement('div');
      strip.className = 'sa-pdp__strip';
      main.parentNode.insertBefore(strip, main);
      thumbs.forEach(function (t, i) {
        var x = i === 0 ? main : document.createElement('img');
        if (i > 0) { x.src = t.dataset.src; x.srcset = t.dataset.srcset || ''; x.sizes = main.sizes; x.alt = t.dataset.alt || ''; x.loading = 'lazy'; x.decoding = 'async'; }
        strip.appendChild(x);
      });
      var raf = 0;
      strip.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(strip.scrollLeft / Math.max(1, strip.clientWidth));
          thumbs.forEach(function (b, j) { b.setAttribute('aria-current', j === i ? 'true' : 'false'); });
        });
      }, { passive: true });
    });
  }

  function init() { initSticky(); initReveal(); initCycle(); initGallery(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); initCycle(e.target); initGallery(e.target); });
})();
